import { CustomerSchema } from "@redotech/redo-model/customer";
import * as z from "zod";

export const getOrCreateCustomerFromPhoneNumber = {
  name: "getOrCreateCustomerFromPhoneNumber" as const,
  input: z.object({ number: z.string() }),
  output: CustomerSchema,
};
